import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Navigate, useSearchParams } from 'react-router-dom';
import LoadingSpinner from '../components/common/LoadingSpinner';
import useAuth from '../hooks/useAuth';

/**
 * Login-Seite: Google-OAuth2 ist der einzige Anmeldeweg.
 *
 * Fehler-Rueckmeldungen des Backends kommen als Query-Parameter:
 * - ?error=forbidden  Google-Konto nicht auf der Whitelist
 * - ?error=oauth      OAuth-Flow fehlgeschlagen
 */
function LoginPage(): React.JSX.Element {
  const { status, login } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  // Waehrend der Token-Validierung: Spinner statt kurz
  // aufblitzendem Login-Formular
  if (status === 'loading') {
    return (
      <div
        id="login-loading"
        className="d-flex align-items-center justify-content-center min-vh-100"
      >
        <LoadingSpinner id="login-loading-spinner" />
      </div>
    );
  }

  // Bereits angemeldet -> direkt zum Dashboard
  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      id="login-page"
      className="d-flex align-items-center justify-content-center min-vh-100 px-3"
    >
      <Card id="login-card" className="shadow-sm w-100" style={{ maxWidth: '26rem' }}>
        <Card.Body id="login-card-body" className="p-4 text-center">
          <i
            id="login-logo-icon"
            className="bi bi-buildings text-primary"
            style={{ fontSize: '2.5rem' }}
          ></i>
          <h1 id="login-heading" className="page-heading h4 mt-2 mb-3">
            MVGen Management
          </h1>

          {error === 'forbidden' && (
            <Alert id="login-error-forbidden" variant="danger" className="text-start">
              Dieses Google-Konto ist nicht berechtigt.
            </Alert>
          )}
          {error === 'oauth' && (
            <Alert id="login-error-oauth" variant="danger" className="text-start">
              Anmeldung fehlgeschlagen. Bitte erneut versuchen.
            </Alert>
          )}

          <p id="login-intro" className="text-muted mb-4">
            Bitte melden Sie sich mit Ihrem Google-Konto an.
          </p>
          <Button
            id="login-google-button"
            variant="primary"
            className="w-100"
            onClick={login}
          >
            <i className="bi bi-google me-2" id="login-google-icon"></i>
            Mit Google anmelden
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}

export default LoginPage;
